import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import displayError from 'shared-components/reduxForms/utilities/displayError';

const AccessTypesFields = ({ fields, meta, errorMessage }) => {
  const { error, submitFailed } = meta;

  return (
    <div className="flex flex-wrap">
      {
        fields.map((option, index) => {
          return (
            <div className="flex-basis-50 flex" key={option.key}>
              <Field
                id={option.key}
                value={option.key}
                key={index}
                className="margin-lg-top"
                component={CheckboxField}
                showErrorOnChange
                name={`space_access_types[${option.key}]`}
                normalize={(value) => value ? option.key : null}
                option={option.key}
                attributes={{
                  'data-testing-id': option.key
                }}
                label={
                  <span>{option.label}</span>
                }
              />
            </div>
          );
        })
      }
      {
        (error && submitFailed) && (
          <p className="error text-danger text-small" style={{ marginTop: '8px' }}>
            {displayError(errorMessage, error)}
          </p>
        )
      }
    </div>
  );
};

AccessTypesFields.propTypes = {
  fields: PropTypes.array,
  meta: PropTypes.object,
  errorMessage: PropTypes.string
};

export default AccessTypesFields;
